var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-5xl mx-auto"},[_c('BaseCard',[_c('BaseCardBody',[_c('FunnelChart',{attrs:{"stages":_vm.stages}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }